import createBaseService from "@/api/base-service.ts";
import type { HelpCategory } from "../../types/help-category";

const helpCategoryService = {
	...createBaseService<HelpCategory>("/help-categories"),
};

export default helpCategoryService;
